import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
  .textarea {
      margin: 35px 0 0;
   }
   .textInput {
      h4 { width: 145px; }
   }
   .guidance {
      margin: 12px 0 4px;
      padding: 10px 12px;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      background: rgb(250, 250, 250);
      color: rgba(0, 0, 0, 0.72);
      font-size: 12px;
      line-height: 1.45;

      p {
         margin: 0;

         &:not(:last-of-type) {
            margin-bottom: 6px;
         }
      }
   }
   .desktopControl {
      margin: 12px 0 4px;
      padding: 12px;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      background: rgb(250, 250, 250);
   }
   .desktopControlHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
   }
   .desktopControlTitle {
      font-size: 12px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.78);
   }
   .desktopControlStatus {
      margin-top: 6px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.62);
      line-height: 1.4;
   }
   .desktopControlButton {
      border: 0;
      border-radius: 6px;
      padding: 7px 12px;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      color: #fff;
      background: #6366f1;
   }
   .desktopControlButton.on {
      background: #334155;
   }
   .desktopControlButton:disabled {
      opacity: 0.55;
      cursor: not-allowed;
   }
   > .title {
      position: relative;
      top: calc(25px / 2);
      left: 7.5px;
      display: inline-flex;
      align-items: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      padding: 0 7.5px;
      height: 25px;
      border-radius: 5px;
      z-index: 99;
   }
   .inputs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      padding: 25px 15px 15px;
      overflow: auto;
      cursor: default;
   }
`;
